import { BrowserRouter as Router, Route, Routes, createBrowserRouter, RouterProvider } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./containers/Footer";
import FooterNew from "./containers/FooterNew";
import Home from "./containers/Home";
// import OurProcess from "./containers/OurProcess";
import AboutUs from "./containers/AboutUs";
import PrivacyPolicy from "./containers/PrivacyPolicy";
import Terms from "./containers/Terms/terms";
import Services from "./containers/Services";
import ScrollToTop from "./components/ScrollToTop";
// import LookingToHirePage from "./containers/LookingToHirePage";
import FloatingButton from "./components/FloatingButton";
// import FindJobs from "./containers/FindJobs";
import Culture from "./containers/Culture";
import NotFound from "./containers/NotFound";
import { ToastContainer } from "react-toastify";
import HireTalent from "./containers/HireTalent";
import ApplyAsTalent from "./containers/ApplyAsTalent";
import UploadResume from "./containers/UploadResume";
import SuccessStories from "./containers/SuccessStories";
import OurCulture from "./containers/OurCulture";
import Jobs from "./containers/Jobs";
import OurBlogs from "./containers/OurBlogs";
// import BlogDescription from "./containers/BlogDescription";
import BlogDetail from "./containers/BlogDetail";
import Layout from "./Layout";
import JobDescriptionLayout from "./containers/JobDescriptionLayout";
import OurBlogsLayout from "./containers/OurBlogsLayout";
import JobsLayout from "./containers/JobDescriptionLayout";
import JobDescription from "./containers/JobDescription";
import { useEffect, useState } from "react";
import initializeSession from "./api/initializeSession";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {

  const queryClient = new QueryClient();
  
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchSession = async () => {
      try{
        await initializeSession();  
        setError(false);
      } catch(error){
        setError(true);
      } finally{
        setLoading(false);
      }
    };
    fetchSession();
  }, []);

  if(loading){
    return <div style={{color: "white"}}></div>  
  }
  if(error){
    return <div style={{color: "white"}}>Please, try reloading the page</div>
  }

  const nuFolksRouter = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Home />
        },
        {
          path: "about",
          element: <AboutUs />
        },
        {
          path: "success-stories",
          element: <SuccessStories /> 
        },
        {
          path: "services",
          element: <Services />
        },
        {
          path: "culture",
          element: <OurCulture />
        },
        {
          path: "blogs",
          element: <OurBlogsLayout />,
          children:[
            {
              index: true,
              element: <OurBlogs />
            },
            {
              path: "blog-detail/:blogId",
              element: <BlogDetail />
            }
          ]
        },
        {
          path: "hire-a-talent",
          element: <HireTalent />
        },
        {
          path: "apply-as-talent",
          element: <ApplyAsTalent />
        },
        {
          path: "upload-your-resume",
          element: <UploadResume />
        },
        {
          path: "jobs",
          element: <JobsLayout />,
          children:[
            {
              index: true,
              element: <Jobs />
            },
            {
              path: "job-description/:jobId",
              element: <JobDescriptionLayout />,
              children:[
                {
                  index: true,
                  element: <JobDescription />
                },
                {
                  path: "apply",
                  element: <ApplyAsTalent />
                }
              ]
            }
          ]
        },
        {
          path: "privacy-policy",
          element: <PrivacyPolicy />
        },
        {
          path: "terms-and-conditions",
          element: <Terms />
        }
      ]
    }
  ])

  return(
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={nuFolksRouter} />
    </QueryClientProvider>
  );

}
export default App;

        // {
        //   path: "jobs",
        //   element: <Jobs />
        // },
//   return (
//     <Router>
  
//       <Routes>
        
//         <Route path="/" element={<Layout />}>
//           <Route index element={<Home />} />
//           <Route path="success-stories" element={<SuccessStories />} />
//           <Route path="about" element={<AboutUs />} />
//           <Route path="privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="terms-and-conditions" element={<Terms />} />
//           <Route path="services" element={<Services />} />
//           <Route path="hire-a-talent" element={<HireTalent />} />
//           <Route path="apply-as-talent" element={<ApplyAsTalent />} />
//           <Route path="culture" element={<OurCulture />} />
//           <Route path="jobs" element={<Jobs />} />
          
//           <Route path="blogs" element={<OurBlogs />}>
//             <Route path="description" element={<BlogDescription />} />
//           </Route>
          
//           <Route path="*" element={<NotFound/>} />
        
//         </Route>
    
//       </Routes>
    
//     </Router>
//   );
// }


// function App() {
  //   return (
  //     <Router>
  //       <ScrollToTop />
  //       {/* <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
  //         <Header />
  //       </div> */}
  //       {/* <FloatingButton label={'Find your Team'} url='./hire-a-talent' />
  //       <FloatingButton label={'Upload CV'} url='./apply-as-a-talent' /> */}
  //       {/* <Header /> */}
  //       <Routes>
  //         <Route path="/" element={<Home />} />
  //         <Route path="/success-stories" element={<SuccessStories />} />
  //         {/* <Route path="/our-process" element={<OurProcess />} /> */}
  //         <Route path="/about" element={<AboutUs />} />
  //         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  //         <Route path="/terms-and-conditions" element={<Terms />} />
  //         <Route path="/services" element={<Services />} />
  //         <Route path="/hire-a-talent" element={<HireTalent />} />
  //         <Route path="/apply-as-talent" element={<ApplyAsTalent />} />
  //         <Route path="/culture" element={<OurCulture />} />
  //         <Route path="/jobs" element={<Jobs />} />
  
  //         <Route path="/blogs" element={<OurBlogs />}>
  //           <Route path="description" element={<BlogDescription />} />
  //         </Route>
  
  //         <Route path="*" element={<NotFound/>} />
  //       </Routes>
  //       <ToastContainer />
  //       {/* <Footer /> */}
  //       <FooterNew />
  //     </Router>
  //   );
  // }